// @ts-nocheck

import { Block, PrensaEngine } from "@xprog/prensa"

import * as S from '../styles'

const TocantinsPageTeam = () => {
  return (
    <S.MainDiv>
      <S.Heading1>Expediente</S.Heading1>
      <Block css={S.logoProps}>
        <img src='/assets/opopular/logos/LogoGrupoJaimeCamara.svg' alt='Logo Grupo Jaime Câmara' height='32px' width='110px' />
      </Block>
      <Block css={S.topBlockProps}>
        <Block css={S.itemTopProps}>
          <S.Heading2>FUNDADOR:</S.Heading2>
          <S.Heading3>Jaime Câmara (1909 - 1989)</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>PRESIDENTE:</S.Heading2>
          <S.Heading3>Jaime Câmara Júnior</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>CEO:</S.Heading2>
          <S.Heading3>Breno Machado</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>VICE-PRESIDENTE DE NEGÓCIOS:</S.Heading2>
          <S.Heading3>Ronaldo Borges Ferrante</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>DIR. JURÍDICO/ REL. INSTITUCIONAIS:</S.Heading2>
          <S.Heading3>Guliver Augusto Leão</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>DIRETOR-GERAL DO GJC NO TOCANTINS</S.Heading2>
          <S.Heading3>Abrão Falluh Hanna</S.Heading3>
        </Block>
      </Block> 
      <Block css={S.logoProps}>
        <img src='/assets/tocantins/logos/LogoTocantinsMobile.svg' alt='Logo Jornal do Tocantins' height='20px' width='153px' />
      </Block> 
      <Block css={S.middleBlockProps}>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>FUNDADORES:</S.Heading2>
          <S.Heading4>Jaime Câmara (1909 - 1989)</S.Heading4>
          <S.Heading4>Joaquim Câmara Filho (1899 - 1955)</S.Heading4>
          <S.Heading4>Rebouças Câmara (1898 - 1973)</S.Heading4>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>DIRETOR SUPERINTENDENTE:</S.Heading2>
          <S.Heading4>Tasso José Câmara</S.Heading4>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>GERENTE DE CONTEÚDO DIGITAL:</S.Heading2>
          <S.Heading4>Elisângela Nascimento</S.Heading4>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>EDITORA-CHEFE</S.Heading2>
          <S.Heading4>Vilma Nascimento</S.Heading4>
        </Block>
      </Block> 
      <Block css={S.bottomBlockProps}>
        <Block css={S.itemBottomProps}>
          <S.Heading2>PUBLICIDADE:</S.Heading2>
          <S.Heading4>(63) 3215-9519</S.Heading4>
        </Block>
        <Block css={S.itemBottomProps}>
          <S.Heading2>CENTRAL DE COMERCIALIZAÇÃO:</S.Heading2>
          <S.Heading4>Telefone: (62) 3250-1215</S.Heading4>
          <S.Heading4>Fax: (62) 3250-1260</S.Heading4>
        </Block>
        <Block css={S.itemBottomProps}>
          <S.Heading2>SUCURSAL SÃO PAULO:</S.Heading2>
          <S.Heading4>Telefone/fax: (11) 3774-8100</S.Heading4>
        </Block>
        <Block css={S.itemBottomProps}>
          <S.Heading2>SUCURSAL BRASÍLIA</S.Heading2>
          <S.Heading4>Telefone: (61) 3321-0501</S.Heading4>
        </Block>
        <Block css={S.itemBottomProps}>
          <S.Heading2>REPRESENTANTE:</S.Heading2>
          <S.Heading4>Rio de Janeiro: (21) 2524-5644</S.Heading4>
          <S.Heading4>Belo Horizonte: (31) 2535-2711 / 8865-7363</S.Heading4>
          <S.Heading4>Vitória: (27) 2124-9739 / 99762-4151</S.Heading4>
        </Block>
      </Block>
    </S.MainDiv>
  )
}

export default TocantinsPageTeam
